import { requester as axios } from "./axios-client";
import packageInfo from "../../../package.json";

export async function checkVersion() {
  const resp = await axios.get("/version");
  if (resp.data && resp.data.version !== packageInfo.version) {
    window.location.reload();
  }
}
